<template>
  <div class="header-info header-info--company">
    <div class="company-name">
      <router-link to="/dashboard">
        <h1><img src="@/assets/icons/logo.gif" />HKTRC 線上教學平台</h1>
      </router-link>
    </div>
    <div class="company-setting">
      <a href="https://hktrc.com.hk">返回網站</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['CurrectStaffProfile'])
  }
}
</script>

<style lang="scss" scoped>
img {
  height: 30px;
  padding-top: 8px;
  margin-right: 1rem;
}
.header-info--company {
  background: var(--color-navy-blue);
  color: var(--color-white);
  line-height: 4rem;
  display: flex;
  justify-content: space-between;

  .company-name {
    text-align: left;
    h1 {
      font-size: 16px;
      display: flex;
    }
  }

  .company-setting {

    a:not(:last-child) {
      margin-right: 1rem;
    }
    svg {
      width: 14px;
      height: 14px;
      position: relative;
      top: 2px;
      margin-right: 6px;
    }
  }
}

</style>
